import React from "react";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ checked, onChange, disabled = false }) => {
    return (
        <button
            type="button"
            className={`toggle-switch ${checked ? "on" : ""} ${disabled ? "disabled" : ""}`}
            onClick={() => !disabled && onChange(!checked)}
        >
            <span />
        </button>
    );
};

export default ToggleSwitch;